import {
  GET_COMMUNITY_PROFILE,
  RESET_COMMUNITY_PROFILE,
  START_LOADING_COMMUNITY,
  STOP_LOADING_COMMUNITY,
  ERROR_LOADING_COMMUNITY,
} from "./action-types";
import { initialState } from "./initialState";

const communityReducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case START_LOADING_COMMUNITY:
      return {
        ...state,
        StateIs: "Pending",
      };

    case ERROR_LOADING_COMMUNITY:
      return {
        ...state,
        StateIs: "Error",
      };

    case STOP_LOADING_COMMUNITY:
      return {
        ...state,
        StateIs: "Idle",
      };
    case GET_COMMUNITY_PROFILE:
      return action.payload;
    case RESET_COMMUNITY_PROFILE:
      return initialState;
    default:
      return state;
  }
};

export default communityReducer;
